import React, { useState } from 'react'
import { TRADECRED_SUPPORT_EMAIL, TRADECRED_SUPPORT_PHONE } from '../../core/constants'
import Text from '../text'
import * as styles from './Footer.css'
import TermsAndConditions from '../termsAndConditions'
import Button from '../button'

export const Footer = () => {
  const [showTNC, setShowTNC] = useState(false)
  const [type, setType] = useState('t&c')

  return (
    <div className={styles.footer}>
      {/* <div className={styles.footerText}>
        <div className={styles.footerAddress}>
          <Text color='#1d1d1f' size='0.81' value='Address' />
          <Text color='#6e6e73' size='0.8' value='Unit 703/704, 7th Floor, Midas Building,' />
          <Text color='#6e6e73' size='0.8' value='Sahar Plaza, Andheri Kurla Road,' />
          <Text color='#6e6e73' size='0.8' value='Andheri(E), Mumbai - 400059' />
        </div>
      </div> */}
      <div className={styles.footerText}>
        <div className={styles.footerAddress}>
          <Text color='#1d1d1f' size='0.81' value='Contact' />
          <Text color='#6e6e73' size='0.8' value={'Email — ' + TRADECRED_SUPPORT_EMAIL} />
          <Text color='#6e6e73' size='0.8' value={'or Call — ' + TRADECRED_SUPPORT_PHONE.join(', ')} />
          <Text color='#6e6e73' size='0.8' value='Mon to Sat 9 AM to 7 PM' />
        </div>
        <div className={styles.footerAddress}>
          <Text color='#1d1d1f' size='0.81' value='Legal' />
          <Button
            type='text'
            handleClick={() => {
              setType('privacy')
              setShowTNC(true)
            }}>
            <Text size='0.8' color='#6e6e73'>
              Privacy Policy
            </Text>
          </Button>
          <Button
            type='text'
            handleClick={() => {
              setType('t&c')
              setShowTNC(true)
            }}>
            <Text size='0.8' color='#6e6e73'>
              Terms & Conditions
            </Text>
          </Button>
          <Button
            type='text'
            handleClick={() => {
              setType('refunds')
              setShowTNC(true)
            }}>
            <Text size='0.8' color='#6e6e73'>
              Refund & Cancellation Policy
            </Text>
          </Button>
        </div>
        <TermsAndConditions showTNC={showTNC} setShowTNC={setShowTNC} type={type} />
      </div>

      <div className={styles.footerDivider}></div>
      <div className={styles.footerTextBottom}>
        <Text color='#6e6e73' size='0.8' value='Copyright ©2024 JKR PLATFORMS LLP. All rights reserved.' />
        <Text color='#6e6e73' size='0.8' value='Mumbai, India' />
      </div>
    </div>
  )
}
